module.exports = ".album-info {\n    padding-left: 3%;\n}\n\n.chip{\n    margin-top: 1%;\n    font-size: medium;\n}\n\n.detailed-follow-btn:hover {\n    background-color: #29b6f6;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/content/detailed/album/album.component.css
// module id = ./src/app/components/dashboard/content/detailed/album/album.component.css
// module chunks = main